import { DocParser, findDate } from '../DocParser';

import { paymentCreateDatePhrases } from '../keywords';

export const getPaymentCreateDateFromName = (doc: string) => {
  const parser = new DocParser(doc);

  return parser.extractRelevantWord(findDate, paymentCreateDatePhrases, 1);
};